import { createContext, useContext, useMemo, type ReactNode } from 'react'
import { translations, type SupportedLanguage, type TranslationKey } from './translations'

interface I18nValue {
  readonly language: SupportedLanguage
  readonly t: (key: TranslationKey) => string
}

const I18nContext = createContext<I18nValue | null>(null)

export function I18nProvider({
  language,
  children,
}: {
  language: SupportedLanguage
  children: ReactNode
}) {
  const value = useMemo<I18nValue>(
    () => ({
      language,
      t: (key) => translations[language][key],
    }),
    [language],
  )
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
}

export function useI18n(): I18nValue {
  const value = useContext(I18nContext)
  if (!value) {
    throw new Error('useI18n() called outside an I18nProvider')
  }
  return value
}
